import { useQuery } from "@tanstack/react-query";

import { getTenants } from "api/tenants";
import { queryKeys } from "./queryKeys";

export const useGetTenants = () => {
  return useQuery({
    queryKey: queryKeys.tenants.all,
    queryFn: getTenants,
  });
};
